module.exports = __webpack_public_path__ + "static/media/035.1a5f00ed.jpg";